import {
    GET_BRANCHES_FAIL,
    GET_BRANCHES_SUCCESS,
    ADD_BRANCH_SUCCESS,
    ADD_BRANCH_FAIL,
    UPDATE_BRANCH_SUCCESS,
    UPDATE_BRANCH_FAIL,
    DELETE_BRANCH_SUCCESS,
    DELETE_BRANCH_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    branches: [],
    error: null,
    loading: true
};

const branchReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des branches
        case GET_BRANCHES_SUCCESS:
            return {
                ...state,
                branches: action.payload, // tableau d'objets branch
                loading: false,
                error: null
            };

        case GET_BRANCHES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une branche
        case ADD_BRANCH_SUCCESS:
            return {
                ...state,
                branches: [action.payload, ...state.branches], // ajoute au début du tableau
                error: null
            };

        case ADD_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une branche
        case UPDATE_BRANCH_SUCCESS:
            return {
                ...state,
                branches: state.branches.map(branch =>
                    branch.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet branch
                        : branch
                ),
                error: null
            };

        case UPDATE_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une branche
        case DELETE_BRANCH_SUCCESS:
            return {
                ...state,
                branches: state.branches.filter(
                    branch => branch.id !== action.payload
                ),
                error: null
            };


        case DELETE_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default branchReducer;
